import { Spinner } from 'components/ui/spinner';

interface LoadingMessageProps {
  label?: string;
}

export const LoadingMessage = ({
  label = 'Loading ...',
  ...rest
}: LoadingMessageProps): JSX.Element => {
  return (
    <div className="flex grow justify-center items-center" {...rest}>
      <div className="flex flex-col">
        <Spinner className="mx-auto h-24 w-24 text-[#88CDD3]" />
        <h1 className="text-center text-xl font-semibold">{label}</h1>
      </div>
    </div>
  );
};
